export default __webpack_public_path__ + "static/media/SWT0810.34I-19780_-24763_0.3e583dcd.jpg";